import { render, staticRenderFns } from "./componentList.vue?vue&type=template&id=04fda686&scoped=true&"
import script from "./componentList.vue?vue&type=script&lang=js&"
export * from "./componentList.vue?vue&type=script&lang=js&"
import style0 from "./componentList.vue?vue&type=style&index=0&id=04fda686&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fda686",
  null
  
)

export default component.exports